/* eslint-disable react/forbid-prop-types */
import { any } from 'prop-types'
import React from 'react'
import { Route } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import LoadingSpinner from '../LoadingSpinner'
import getLoadingFallback from '../../helpers/loadingFallback'

export default function AuthRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  const { signedIn, userLoading } = useUser()
  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => (
        <>
          {userLoading && getLoadingFallback(<LoadingSpinner size="lg" />)}
          {!userLoading && signedIn && <Component {...props} />}
          {!userLoading && !signedIn && <Fallback {...props} />}
        </>
      )}
      requirePersonalData={requirePersonalData}
    >
      {children}
    </Route>
  )
}

AuthRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
}
